import { FC, useEffect, useState } from 'react'
import { Box, Typography } from '@mui/material'
import { CardType } from '@edge/spark/io-dashboards'
import { SingleNumberWidget } from '../../BaseComponents/SingleNumberWidget'
import type { BasicWidgetProps } from '../../types'
import { getActiveAuctionId } from '@edge/spark/io-roles'
import { AuctionAsset, useGetOrderInspectionsQuery } from 'src/generated-unified/graphql'
import { ApolloClientLinksEnum } from 'src/components/ApolloClient/helpers/clientsEnum'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { filterPsiVehicles, filterPsiVehiclesResult } from '../../../../Views/PostSaleInspectionsPlus/utils'

const DEFAULT_CARD_HEADER = 'Vehicles'
const DEFAULT_TEXT = 'Eligible for PSI+'
const DEFAULT_ACTION_TEXT = 'View Eligible Vehicles'

const UnifiedPSIEligible: FC<BasicWidgetProps> = ({ config, widgetId, handleConfig, readonly }: BasicWidgetProps) => {
    const cardHeaderText = config.title || DEFAULT_CARD_HEADER
    const actionText = config.linklabel || DEFAULT_ACTION_TEXT
    const actionLink = `/postsaleinspections-plus/eligible`
    const widgetText = config.label || DEFAULT_TEXT
    const { releasePsiPlus } = useFlags()
    const [psiStatusCounts, setPsiStatusCounts] = useState<filterPsiVehiclesResult>()

    const auctionId = getActiveAuctionId()
    const { data, loading } = useGetOrderInspectionsQuery({
        variables: { auctionId },
        context: { clientName: ApolloClientLinksEnum.unifiedApi },
        skip: !releasePsiPlus,
    })

    useEffect(() => {
        const vehicles = data?.auction?.assets?.purchased?.items || []
        const filteredResults = filterPsiVehicles(vehicles as AuctionAsset[])
        setPsiStatusCounts(filteredResults)
    }, [data])

    return (
        <SingleNumberWidget
            cardType={CardType.VEHICLE}
            cardHeaderText={cardHeaderText}
            action={{
                text: actionText,
                link: actionLink,
            }}
            loading={loading}
            number={psiStatusCounts?.eligible?.length || '--'}
            text={widgetText}
            text2={config.label2}
            secondaryText={
                <Box display="flex" flexDirection="column">
                    <Typography variant="caption" align="left">
                        Ordered: {psiStatusCounts?.ordered?.length || '--'}
                    </Typography>
                    <Typography variant="caption" align="left">
                        Completed: {psiStatusCounts?.completed?.length || '--'}
                    </Typography>
                </Box>
            }
            widgetId={widgetId}
            handleConfig={handleConfig}
            readonly={readonly}
        />
    )
}

export default UnifiedPSIEligible
